import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EOtpModalActionTypes {
  OpenOtpModal = 'OTP_MODAL/OpenOtpModal',
  CloseOtpModal = 'OTP_MODAL/CloseOtpModal',
}

export const openOtpModal = actionGenerator<EOtpModalActionTypes.OpenOtpModal, void>(EOtpModalActionTypes.OpenOtpModal);
export const closeOtpModal = actionGenerator<EOtpModalActionTypes.CloseOtpModal, void>(
  EOtpModalActionTypes.CloseOtpModal,
);

export type TOpenOtpModal = ITypedReduxAction<EOtpModalActionTypes.OpenOtpModal, void>;
export type TCloseOtpModal = ITypedReduxAction<EOtpModalActionTypes.CloseOtpModal, void>;

export type TOtpModalActions = TOpenOtpModal | TCloseOtpModal;
